// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root___lwHQ","additionalInfo":"AgreementModal_additionalInfo__3sYAT"};